import React from 'react'
import { 
  Button, 
  Icon, 
  Table
} from 'semantic-ui-react'
// Local
import If from './if'
import ReveleerButton from './ReveleerButton'
import { shouldRenderReskin2025 } from '../../constant'

type Props = {
  columns: number
  onMore: () => void
}

function MoreTableFooter(
  props: Props
): JSX.Element {
  const {
    columns,
    onMore
  } = props
  return (
    <Table.Footer>
      <Table.Row>
        <Table.HeaderCell
          className="table-footer-max"
          colSpan={ columns }
        >
          <If isTrue={ !shouldRenderReskin2025 }>
            <Button
              id="more-table-footer-load-more-records"
              className="table-button"
              color="blue"
              size="small"
              onClick={ onMore }
            >
              <Icon name="arrow down" />Load More Records
            </Button>
          </If>
          <If isTrue={ shouldRenderReskin2025 }>
            <ReveleerButton
              buttonLabel="Load More Records"
              buttonSize="small"
              buttonType="primary"
              id="more-table-footer-load-more-records"
              isDisabled={ false }
              onClick={ onMore }
              type="button"
            />
          </If>
        </Table.HeaderCell>
      </Table.Row>
    </Table.Footer>
  )
}

export default MoreTableFooter
